// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5b-0";
export var eligibilityCardNotEligible = "_5b-1";